function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M75 33.333h-4.167V25C70.833 13.5 61.5 4.167 50 4.167 38.5 4.167 29.167 13.5 29.167 25v8.333H25c-4.583 0-8.333 3.75-8.333 8.334v41.666c0 4.584 3.75 8.334 8.333 8.334h50c4.583 0 8.333-3.75 8.333-8.334V41.667c0-4.584-3.75-8.334-8.333-8.334zm-25 37.5c-4.583 0-8.333-3.75-8.333-8.333s3.75-8.333 8.333-8.333 8.333 3.75 8.333 8.333-3.75 8.333-8.333 8.333zm12.917-37.5H37.083V25c0-7.125 5.792-12.917 12.917-12.917S62.917 17.875 62.917 25v8.333z",
  fill: "currentColor"
});
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _ref);
};
export default SvgLocked;